module.exports = __webpack_public_path__ + "img/svg/logo-icon.3d8f48a1c54a842b1307877bf7b437dc.svg";